import React, { useCallback, useContext, useEffect, useRef, useState, } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { useReducedMotion } from '@wix/da-hooks/pkg/useReducedMotion';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { ThemeContext, ThemeSkinContext, } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CloseIcon from '@wix/da-ds/pkg/Icons/24x24/Close';
import TierIcon from '@wix/da-ds/pkg/Icons/Tier';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/ArrowDown';
import { useSubscriptionLockFTUE } from '../useSubscriptionLockFTUE';
import s from './SubscriptionLockLitFTUE.scss';
/** Displays a ftue popup for first time viewers of in-tier, lit/journal deviations
 *  from ArtStage/DesktopTextualArtStage that tells the user to scroll down to subscribe. */
export var SubscriptionLockLitFTUE = function (_a) {
    var className = _a.className, deviation = _a.deviation;
    var t = useTranslation().t;
    var isMounted = useIsMounted();
    // ...seems like all of this could have been simpler since it's svg
    var theme = useContext(ThemeContext);
    var themeSkin = useContext(ThemeSkinContext);
    var hexagonTheme = theme;
    if (themeSkin === 'light-green') {
        hexagonTheme = 'green';
    }
    var hexagonUrl = Url.staticCDNLink("eclipse/global/svg/hexagon-".concat(hexagonTheme, ".svg"));
    var fellaUrl = Url.staticCDNLink("eclipse/global/svg/fella-pointing-down".concat(theme === 'light' ? '-light' : '', ".svg"));
    var rootRef = useRef(null);
    var isMobile = useContext(MobileContext);
    var _b = useSubscriptionLockFTUE(deviation), isFlagUp = _b.isSubscriptionLockFTUEShown, dropFlag = _b.dropFlag;
    var _c = useState(!isMobile && isFlagUp), isShown = _c[0], setIsShown = _c[1];
    var prefersReducedMotion = useReducedMotion();
    var _d = useState(false), fadingOut = _d[0], setFadingOut = _d[1];
    var dropFlagAndFadeOut = useCallback(function () {
        if (!rootRef.current || !isShown) {
            return;
        }
        dropFlag();
        if (prefersReducedMotion) {
            setIsShown(false);
            return;
        }
        var handler = function (e) {
            e.target === rootRef.current && setIsShown(false);
        };
        rootRef.current.addEventListener('transitionend', handler);
        setFadingOut(true);
        return function () {
            var _a;
            (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('transitionend', handler);
        };
    }, [rootRef, isShown, prefersReducedMotion, dropFlag]);
    useEffect(function () {
        isShown &&
            typeof window !== 'undefined' &&
            window.addEventListener('scroll', dropFlagAndFadeOut, { once: true });
        return function () { return window.removeEventListener('scroll', dropFlagAndFadeOut); };
    }, [isShown, dropFlagAndFadeOut]);
    if (!isShown) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], isMounted && s['ready'], fadingOut && s['fading-out'], className), onClick: dropFlagAndFadeOut, ref: rootRef },
        React.createElement("div", { className: s['fella-popup'] },
            React.createElement("img", { className: s['hexagon'], src: hexagonUrl, alt: "" }),
            React.createElement("span", { className: s['fake-close-button'] },
                React.createElement(CloseIcon, null)),
            React.createElement("section", { className: s['ftue-explanation'] },
                React.createElement(TierIcon, { className: s['tier-icon'] }),
                React.createElement("p", null, t('deviation.tier.ftue.subscriptionLockLit')),
                React.createElement("p", { className: s['fake-link'] }, t('common.gotIt'))),
            React.createElement("img", { className: s['fella'], src: fellaUrl, alt: "" }),
            React.createElement("div", { className: s['arrows-down'] },
                React.createElement(ArrowDownIcon, null),
                React.createElement(ArrowDownIcon, null)))));
};
SubscriptionLockLitFTUE.displayName = 'SubscriptionLockLitFTUE';
export default SubscriptionLockLitFTUE;
//# sourceMappingURL=SubscriptionLockLitFTUE.js.map